var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7001 6.29998C14.5169 6.48691 14.4142 6.73823 14.4142 6.99998C14.4142 7.26173 14.5169 7.51305 14.7001 7.69998L16.3001 9.29998C16.487 9.48321 16.7383 9.58584 17.0001 9.58584C17.2619 9.58584 17.5132 9.48321 17.7001 9.29998L21.4701 5.52998C21.9729 6.64117 22.1252 7.87921 21.9066 9.07913C21.6879 10.279 21.1088 11.3838 20.2464 12.2463C19.3839 13.1087 18.2792 13.6878 17.0792 13.9064C15.8793 14.1251 14.6413 13.9728 13.5301 13.47L6.6201 20.38C6.22227 20.7778 5.68271 21.0013 5.1201 21.0013C4.55749 21.0013 4.01792 20.7778 3.6201 20.38C3.22227 19.9822 2.99878 19.4426 2.99878 18.88C2.99878 18.3174 3.22227 17.7778 3.6201 17.38L10.5301 10.47C10.0273 9.35879 9.87502 8.12075 10.0936 6.92083C10.3123 5.72092 10.8914 4.61614 11.7538 3.7537C12.6163 2.89127 13.721 2.31215 14.921 2.09352C16.1209 1.8749 17.3589 2.02714 18.4701 2.52998L14.7101 6.28998L14.7001 6.29998Z",
    stroke: "#181C32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool);
export default __webpack_public_path__ + "static/media/tool.9f5dd2bf6cfc6126284262f5d45c63d7.svg";
export { ForwardRef as ReactComponent };